<template>
  <section 
    id="about" 
    class="flex flex-col-reverse lg:flex-row items-center justify-between py-10 px-4 sm:px-6 md:px-8 lg:px-16 bg-slate-900 text-white shadow-xl font-poppins lg:gap-12 w-full overflow-x-hidden"
  >
    <!-- Texto -->
    <div 
      class="text-center lg:text-left lg:w-1/2 mb-8 lg:mb-0"
      data-aos="fade-right"
    >
      <h2 class="text-2xl sm:text-3xl lg:text-5xl font-semibold mb-4 mt-8">
        Conheça a Dra. Rose Mary
      </h2>
      <p class="text-sm sm:text-base lg:text-lg mb-3">
        A Dra. Rose Mary é a proprietária do Instituto de Odontologia Rodrigues. 
        Ela é especialista em odontologia estética, dentística e odontopediatria. 
        Possui mais de 35 anos de profissão, sempre oferecendo uma odontologia de excelência para os seus pacientes.
      </p>
      <p class="text-sm sm:text-base lg:text-lg mb-5">
        Nós temos o prazer de apresentar o IOR para vocês. Confira os nossos serviços:
      </p>
      <a 
        :href="whatsappLink"
        target="_blank"
        class="inline-flex items-center py-2 px-4 sm:py-3 sm:px-6 bg-purple-900 text-white font-semibold rounded-lg shadow-md hover:bg-gray-500 transition-colors"
      >
        Agende sua consulta
        <img 
          src="@/assets/images/logowpp.svg" 
          alt="WhatsApp" 
          class="w-6 h-6 sm:w-7 sm:h-7 ml-2" 
        />
      </a>
    </div>

    <!-- Foto -->
    <div 
      class="lg:w-1/2 flex justify-center rounded-lg"
      data-aos="fade-left"
    >
      <img 
        src="@/assets/images/drarose.png" 
        alt="Dra. Rose Mary" 
        class="w-full max-w-[600px] object-cover rounded-lg transform transition-transform duration-300 hover:scale-105" 
        aria-hidden="true"
      />
    </div>
  </section>
</template>

<script setup>
const phoneNumber = "5561999757400"; 
const message = "Olá, vim através do site e gostaria de agendar uma consulta!";
const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
</script>
